module.exports = __webpack_public_path__ + "static/media/Transfer.4ca23b35.png";